import { render, staticRenderFns } from "./gongjiaoInfo.vue?vue&type=template&id=06151852&scoped=true&"
import script from "./gongjiaoInfo.vue?vue&type=script&lang=js&"
export * from "./gongjiaoInfo.vue?vue&type=script&lang=js&"
import style0 from "./gongjiaoInfo.vue?vue&type=style&index=0&id=06151852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06151852",
  null
  
)

export default component.exports